class window.CopyUrlShare
  constructor: ->
    @urlInput = $("#copy-path-input")
    @copyButton = $("#copy-path-button")

    @init()

  init: ->
    self = this
    @copyButton.click ->
      self.copyUrl()

  copyUrl: ->
    url = @urlInput.val()
    r = undefined
    if window.clipboardData && window.clipboardData.setData
      r = clipboardData.setData("Text", url)
    else if document.queryCommandSupported && document.queryCommandSupported("copy")
      textarea = document.createElement('textarea')
      textarea.textContent = url;
      textarea.style.position = "absolute"
      textarea.style.left = "-9999px"
      document.body.appendChild(textarea)
      textarea.select()

      try
        r = document.execCommand("copy")
      catch ex
        r = false
      unless error?
        document.body.removeChild(textarea)

    if r
      alert("Ссылка успешно скопирована!")
    else
      alert("Не удалось скопировать ссылку")


// WEBPACK FOOTER //
// ./assets/javascripts/app/copy_url_share.coffee